
export enum ImageTypeEnum {
    url,
    font,
    fileType
}
